import { CLOSE_LOADER, LOADER_OPEN } from "../store/dialogue/dialogue.type";
import { baseURL, secretKey } from "./config";
import store from "../store/Provider";
import { setToast } from "./toast";

export const openSpinner = () => {
  return store.dispatch({ type: LOADER_OPEN });
};

export const closeSpinner = () => {
  return store.dispatch({ type: CLOSE_LOADER });
};

const token = sessionStorage.getItem("token");

export const apiInstance = {
  baseURL: `${baseURL}`,
  headers: {
    "Content-Type": "application/json",
    key: `${secretKey}`,
    Authorization: `Bearer ${token}`,
  },
  get: (url) => {
    openSpinner();
    return fetch(`${apiInstance?.baseURL}${url}`, {
      method: "GET",
      headers: { ...apiInstance.headers },
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  post: (url, data) => {
    openSpinner();
    return fetch(`${apiInstance.baseURL}${url}`, {
      method: "POST",
      headers: { ...apiInstance.headers },
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  patch: (url, data) => {
    openSpinner();
    return fetch(`${apiInstance.baseURL}${url}`, {
      method: "PATCH",
      headers: { ...apiInstance.headers },
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  put: (url, data) => {
    openSpinner();
    return fetch(`${apiInstance.baseURL}${url}`, {
      method: "PUT",
      headers: { ...apiInstance.headers },
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  delete: (url) => {
    openSpinner();
    return fetch(`${apiInstance.baseURL}${url}`, {
      method: "DELETE",
      headers: apiInstance.headers,
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },
};

async function handleErrors(response) {
  const resp = await response.json();
  if (!resp.status) {
    setToast(resp.toastType || "error", resp.message);
    if (resp.message2) setToast("info", resp.message2);
  }
  // if (response.status === 403) {
  //   // Clear session and logout user on 403 error
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   axios.defaults.headers.common["key"] = "";
  //   axios.defaults.headers.common["Authorization"] = "";
  //   window.location.href = "/";
  // } else if (response.status === 500) {
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   axios.defaults.headers.common["key"] = "";
  //   axios.defaults.headers.common["Authorization"] = "";
  //   window.location.href = "/";
  // }
  return resp;
}
